import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import CommonPopup from '../../components/popup/CommonPopup';
import dayjs from 'dayjs';
import { ReactComponent as NoData } from '../../images/no-data.svg';
import { ReactComponent as COEImage } from '../../images/coe.svg';
import { ReactComponent as PARFImage } from '../../images/parf.svg';
import { ReactComponent as BodyImage } from '../../images/body_only.svg';
import axios from '../../axios/axios';
import FloorRatesModal from './FloorRatesModal';
import { toast } from 'react-toastify';
import FloorScheduleRatesModal from './FloorScheduleRates';
import { useLocation } from 'react-router-dom';

const GetFloorImages = (name) => {
  switch (name) {
    case 'COE':
      return <COEImage />;
    case 'PARF':
      return <PARFImage />;
    case 'BODY ONLY':
      return <BodyImage />;
  }
};

const DefaultScheduleArray = [
  {
    id: 0,
    name: 'COE',
    interest_from: '',
    interest_to: '',
    admin_fee_from: '',
    admin_fee_to: '',
    scheduled_date_time: '',
    active: 0,
  },
  {
    id: 0,
    name: 'PARF',
    interest_from: '',
    interest_to: '',
    admin_fee_from: '',
    admin_fee_to: '',
    scheduled_date_time: '',
    active: 0,
  },
  {
    id: 0,
    name: 'BODY ONLY',
    interest_from: '',
    interest_to: '',
    admin_fee_from: '',
    admin_fee_to: '',
    scheduled_date_time: '',
    active: 0,
  },
];
const ConvertArrayToObj = (arr) => {
  var mapped = arr.map((item) => ({
    [item.name.replace(/ /g, '')]:
      item.active == '' ? false : item.active == 0 ? true : false,
  }));
  var newObj = Object.assign({}, ...mapped);
  return newObj;
};
const CompareArrays = (result1, result2) => {
  var result = result1.filter(function (o1) {
    return !result2.some(function (o2) {
      return o1.name === o2.name;
    });
  });
  return result;
};

const ConvertScheduleDate = (arr) => {
  var mapped = arr.map((item) => ({
    [item.name.replace(/ /g, '')]: dayjs(item?.scheduled_date_time).valueOf(),
  }));
  var dateObj = Object.assign({}, ...mapped);
  return dateObj;
};

const GetScheduleDateTime = (arr) => {
  if (arr?.length > 0) {
    const temp = arr.pop();
    return (
      <h2 className='isScheduled'>
        <span>Scheduled Changes on:</span> {temp?.scheduled_date_time}
      </h2>
    );
  } else {
    return (
      <h2 className='isScheduled'>
        <span>Scheduled Changes on:</span> {'No Schedule Date Found..'}
      </h2>
    );
  }
};

const checkedDefaultValues = {
  COE: false,
  PARF: false,
  BODYONLY: false,
};

const ScheduleDefaultValues = {
  COE: null,
  PARF: null,
  BODYONLY: null,
};

const FlooringRates = () => {
  const location = useLocation();
  const pagePermission = location.state;
  const accessToken = localStorage.getItem('agentModuleToken');

  console.log("FLOORATEPERMISSION", pagePermission);

  const [formValues, setFormValues] = useState({
    products: [
      {
        name: 'COE',
        interest_from: '',
        interest_to: '',
        admin_fee_from: '',
        admin_fee_to: '',
        active: 1,
      },
      {
        name: 'PARF',
        interest_from: '',
        interest_to: '',
        admin_fee_from: '',
        admin_fee_to: '',
        active: 1,
      },
      {
        name: 'BODY ONLY',
        interest_from: '',
        interest_to: '',
        admin_fee_from: '',
        admin_fee_to: '',
        active: 1,
      },
    ],
  });
  const [scheduleFormValues, setScheduleFormValues] = useState({
    scheduled_products: DefaultScheduleArray,
  });
  const [flooringRates, setFlooringRates] = useState({
    products: [],
    scheduled_products: [],
  });
  const [isChecked, setIsChecked] = useState(checkedDefaultValues);
  const [scheduleDates, setScheduleDates] = useState(ScheduleDefaultValues);

  const [isModalOpen, setIsModalOpen] = useState({
    open: false,
    type: 'create',
  });
  const [isScheduleModalOpen, setIsScheduleModalOpen] = useState({
    open: false,
    type: 'create',
  });

  const openModal = (type) => {
    setIsModalOpen({ open: true, type });
    setIsChecked(ConvertArrayToObj(formValues?.products));
  };

  const closeModal = () => {
    setIsModalOpen({ open: false, type: 'create' });
    setIsChecked(checkedDefaultValues);
  };

  const openScheduleModal = (type) => {
    setIsScheduleModalOpen({ open: true, type });
    setIsChecked(checkedDefaultValues);
  };
  const closeScheduleModal = () => {
    setIsScheduleModalOpen({ open: false, type: 'create' });
    setScheduleDates(DefaultScheduleArray);
    setIsChecked(checkedDefaultValues);
  };

  const GetFlooringRates = async () => {
    const resp = await axios.get('/flooring/product', {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    if (resp?.status < 400) {
      setFlooringRates({
        products: resp.data?.data?.products,
        scheduled_products: resp.data?.data?.scheduled_products,
      });
      const FlooringRatesProducts = resp.data?.data?.products;
      const FlooringRatesSchedule = resp.data?.data?.scheduled_products;

      if (FlooringRatesProducts?.length > 0) {
        setFormValues({ products: FlooringRatesProducts });
      }
      if (FlooringRatesSchedule?.length > 0) {
        const missingScheduleValues = CompareArrays(
          DefaultScheduleArray,
          FlooringRatesSchedule
        );
        setScheduleFormValues({
          scheduled_products: FlooringRatesSchedule?.concat(
            missingScheduleValues
          ),
        });
        setScheduleDates({
          ...scheduleDates,
          ...ConvertScheduleDate(FlooringRatesSchedule),
        });
      } else {
        setScheduleFormValues({
          scheduled_products: FlooringRatesProducts?.map((it) => {
            return {
              ...it,
              scheduled_date_time: null,
              active: it.active == 1 ? 0 : 1,
            };
          }),
        });
      }
    }
  };

  const onSubmit = async (data) => {
    if (isModalOpen?.type === 'create') {
      const FormData = data?.products.map((it) => {
        return {
          ...it,
          name: it.name.replace(/ /g, ''),
        };
      });
      console.log('FORM DATA', FormData);
      const resp = await axios.post(
        '/flooring/product/create',
        {
          products: FormData,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (resp?.status < 400) {
        toast.success('Flooring Product created successfully');
        setIsModalOpen({ open: false, type: 'create' });
        GetFlooringRates();
      }
    } else {
      const FormData = data?.products.map((it) => {
        return {
          ...it,
          name: it.name.replace(/ /g, ''),
        };
      });
      const resp = await axios.post(
        '/flooring/product/update',
        {
          products: FormData,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (resp.status < 400) {
        toast.success(resp.data?.message);
        setIsModalOpen({ open: false, type: 'create' });
        GetFlooringRates();
      }
    }
  };

  const OnscheduleSubmit = async (data) => {
    if (isScheduleModalOpen?.type === 'create') {
      const FormData = data?.scheduled_products
        .map((it) => {
          return {
            ...it,
            name: it.name.replace(/ /g, ''),
            scheduled_date_time:
              scheduleDates[it?.name?.replace(/ /g, '')] !== null
                ? dayjs(scheduleDates[it?.name?.replace(/ /g, '')]).format(
                  'DD-MM-YYYY HH:mm:ss'
                )
                : '',
          };
        })
        ?.filter((it) => it.active !== 1 && it.interest_from !== '');
      const resp = await axios.post(
        '/flooring/product/update',
        {
          products: FormData,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (resp?.status < 400) {
        toast.success(resp.data?.message);
        setIsScheduleModalOpen({ open: false, type: 'create' });
        setScheduleDates(DefaultScheduleArray);
        GetFlooringRates();
      }
    } else {
      const FormData = data?.scheduled_products
        .map((it) => {
          return {
            ...it,
            name: it.name.replace(/ /g, ''),
            scheduled_date_time:
              scheduleDates[it?.name?.replace(/ /g, '')] !== null
                ? dayjs(scheduleDates[it?.name?.replace(/ /g, '')]).format(
                  'DD-MM-YYYY HH:mm:ss'
                )
                : '',
          };
        })
        ?.filter((it) => it.interest_from !== '');
      const resp = await axios.post(
        '/flooring/product/update',
        {
          products: FormData,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (resp.status < 400) {
        toast.success(resp.data?.message);
        setIsScheduleModalOpen({ open: false, type: 'create' });
        GetFlooringRates();
        setScheduleDates(DefaultScheduleArray);
      }
    }
  };

  function UserDataCard({ data, type }) {
    const temp =
      type === 'scheduled' && data?.name !== undefined
        ? flooringRates?.products?.filter((it) => it.name === data?.name).pop()
        : [];
    return Object.keys(data)?.length > 0 ? (
      <div
        className='mini-card'
        style={{
          opacity:
            type === 'scheduled'
              ? data?.active == 1
                ? '0.6'
                : 'auto'
              : data?.active == 0
                ? '0.6'
                : 'auto',
        }}
      >
        <div className='mini-card-image'>{GetFloorImages(data?.name)}</div>
        <h3>{data?.name}</h3>
        <div>
          <p>
            Flooring Interest (30 days):{' '}
            <span
              style={{
                color:
                  type === 'scheduled'
                    ? Number(temp?.interest_to) !== Number(data?.interest_to) ||
                      Number(temp?.interest_from) !==
                      Number(data?.interest_from)
                      ? '#055FFB'
                      : ''
                    : '',
              }}
            >
              {data?.interest_from}% - {data?.interest_to}%
            </span>
          </p>
          <p>
            Admin Fee:{' '}
            <span
              style={{
                color:
                  type === 'scheduled'
                    ? Number(temp?.admin_fee_from) !==
                      Number(data?.admin_fee_from) ||
                      Number(temp?.admin_fee_to) !== Number(data?.admin_fee_to)
                      ? '#055FFB'
                      : ''
                    : '',
              }}
            >
              ${data?.admin_fee_from} - ${data?.admin_fee_to}
            </span>
          </p>
        </div>
      </div>
    ) : (
      <div
        className='mini-card'
        style={{
          opacity: '0.6',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div className='no-data-found'>
          <h3>
            {type === 'scheduled'
              ? `No Schedule Data Found..!`
              : 'No Flooring Rate Found..!'}
          </h3>
        </div>
      </div>
    );
  }

  useEffect(() => {
    GetFlooringRates();
  }, []);
  const ScheduleCOEData = flooringRates?.scheduled_products?.filter(
    (it) => it?.name === 'COE'
  );
  const SchedulePARFData = flooringRates?.scheduled_products?.filter(
    (it) => it?.name === 'PARF'
  );
  const ScheduleBODYONLYData = flooringRates?.scheduled_products?.filter(
    (it) => it?.name === 'BODY ONLY'
  );

  console.log('formValues', formValues);

  return (
    <section className='flooring-rates-section'>
      <header className='common-header'>
        <div className='common-header-body'>
          <h1>Flooring Rates</h1>
          <div className='flex'>
            {pagePermission?.create_permission == 1 && formValues?.products?.length > 0 &&
              formValues?.products[0]?.interest_from !== '' && (
                <Button
                  type='button'
                  className='sav_btn bonus_btn'
                  style={{ marginRight: '10px' }}
                  onClick={() => {
                    openScheduleModal(
                      flooringRates?.scheduled_products?.length > 0
                        ? 'edit'
                        : 'create'
                    );
                  }}
                >
                  <img
                    src='/images/add-circle-wh.svg'
                    alt='add'
                    className='hidden max-[700px]:block'
                  />
                  <span className='max-[700px]:hidden'>
                    {flooringRates?.scheduled_products?.length > 0
                      ? 'Edit Schedule Rates'
                      : 'Create New Schedule Rates'}
                  </span>
                </Button>
              )}
            {pagePermission?.update_permission == 1 && (
              <Button
                type='button'
                className='sav_btn bonus_btn'
                onClick={() => {
                  openModal(
                    flooringRates?.products?.length > 0 ? 'edit' : 'create'
                  );
                }}
              >
                <img
                  src='/images/edit_ic white.svg'
                  alt='add'
                  className='hidden max-[700px]:block'
                />
                <span className='max-[700px]:hidden'>
                  {flooringRates?.products?.length > 0
                    ? 'Edit Rates'
                    : 'Create New Rates'}
                </span>
              </Button>
            )}
          </div>
        </div>
      </header>
      <section className='flooring-body-section'>
        {flooringRates?.products?.length > 0 ? (
          <div className='flooring-data-block'>
            <div>
              <h2>Your Flooring Rates</h2>
              <div className='flooring-data-group mb-8'>
                {/* {flooringRates?.products.map((item, index) => (
                  <UserDataCard key={index} data={item} type={"current"} />
                ))} */}
                <UserDataCard
                  key={1}
                  data={
                    flooringRates?.products?.filter((it) => it?.name === 'COE')
                      ?.length > 0
                      ? flooringRates?.products
                        ?.filter((it) => it?.name === 'COE')
                        .pop()
                      : {}
                  }
                  type={'current'}
                />
                <UserDataCard
                  key={1}
                  data={
                    flooringRates?.products?.filter((it) => it?.name === 'PARF')
                      ?.length > 0
                      ? flooringRates?.products
                        ?.filter((it) => it?.name === 'PARF')
                        .pop()
                      : {}
                  }
                  type={'current'}
                />
                <UserDataCard
                  key={1}
                  data={
                    flooringRates?.products?.filter(
                      (it) => it?.name === 'BODY ONLY'
                    )?.length > 0
                      ? flooringRates?.products
                        ?.filter((it) => it?.name === 'BODY ONLY')
                        .pop()
                      : {}
                  }
                  type={'current'}
                />
              </div>
              {flooringRates?.scheduled_products?.length > 0 && (
                <div className='scheduled_block'>
                  <div className='flooring-data-group'>
                    <div>
                      {GetScheduleDateTime(ScheduleCOEData)}
                      <UserDataCard
                        key={1}
                        data={
                          flooringRates?.scheduled_products?.filter(
                            (it) => it?.name === 'COE'
                          )?.length > 0
                            ? flooringRates?.scheduled_products
                              ?.filter((it) => it?.name === 'COE')
                              .pop()
                            : {}
                        }
                        type={'scheduled'}
                      />
                    </div>
                    <div>
                      {GetScheduleDateTime(SchedulePARFData)}
                      <UserDataCard
                        key={1}
                        data={
                          flooringRates?.scheduled_products?.filter(
                            (it) => it?.name === 'PARF'
                          )?.length > 0
                            ? flooringRates?.scheduled_products
                              ?.filter((it) => it?.name === 'PARF')
                              .pop()
                            : {}
                        }
                        type={'scheduled'}
                      />
                    </div>
                    <div>
                      {GetScheduleDateTime(ScheduleBODYONLYData)}
                      <UserDataCard
                        key={1}
                        data={
                          flooringRates?.scheduled_products?.filter(
                            (it) => it?.name === 'BODY ONLY'
                          )?.length > 0
                            ? flooringRates?.scheduled_products
                              ?.filter((it) => it?.name === 'BODY ONLY')
                              .pop()
                            : {}
                        }
                        type={'scheduled'}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className='no_data_found'>
            <div className='no_data_found_info'>
              <NoData />
              <h2>Oh oh! No Flooring Rates Found</h2>
              <p>
                Seems like you don’t have any flooring rates available click
                below to create new one
              </p>
              {pagePermission?.create_permission == 1 && (
                <Button
                  type='button'
                  className='sav_btn bonus_btn'
                  onClick={() => {
                    openModal('create');
                  }}
                >
                  <img
                    src='/images/add-circle-wh.svg'
                    alt='add'
                    className='hidden max-[700px]:block'
                  />
                  <span className='max-[700px]:hidden'>Create New Rates</span>
                </Button>
              )}
            </div>
          </div>
        )}
      </section>
      {isModalOpen?.open && (
        <CommonPopup
          size='xl'
          isOpen={isModalOpen.open}
          onClose={closeModal}
          title={
            isModalOpen?.type === 'edit'
              ? 'Update Flooring Rates'
              : 'Create Flooring Rates'
          }
        >
          <FloorRatesModal
            onSubmit={onSubmit}
            isChecked={isChecked}
            setIsChecked={setIsChecked}
            isModalOpen={isModalOpen}
            formValues={formValues}
          />
        </CommonPopup>
      )}
      {isScheduleModalOpen?.open && (
        <CommonPopup
          size='xl'
          isOpen={isScheduleModalOpen.open}
          onClose={closeScheduleModal}
          title={
            isScheduleModalOpen?.type === 'edit'
              ? 'Update Schedule Rates'
              : 'Create Schedule Rates'
          }
        >
          <FloorScheduleRatesModal
            onSubmit={OnscheduleSubmit}
            isChecked={isChecked}
            setIsChecked={setIsChecked}
            isModalOpen={isScheduleModalOpen}
            formValues={scheduleFormValues}
            scheduleDates={scheduleDates}
            setScheduleDates={setScheduleDates}
          />
        </CommonPopup>
      )}
    </section>
  );
};

export default FlooringRates;
